"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _initResponseFileInfo = _interopRequireDefault(require("./init-response-file-info"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Represents a part of a file to upload, based on the response from the direct binary upload initiate request.
 */
var InitResponseFilePart = /*#__PURE__*/function (_InitResponseFileInfo) {
  _inherits(InitResponseFilePart, _InitResponseFileInfo);

  var _super = _createSuper(InitResponseFilePart);

  /**
   * Constructs a new part instance, which can be used to retrieve information about the file part.
   *
   * @param {object} options Options controlling the overall process.
   * @param {DirectBinaryUploadOptions} uploadOptions Options controlling the upload process.
   * @param {UploadFile} uploadFile The original upload file from which the init data is based.
   * @param {object} fileData Raw file data as received from the init api.
   * @param {object} partOptions Raw part data as received from the direct binary upload initiate request.
   */
  function InitResponseFilePart(options, uploadOptions, uploadFile, fileData, partOptions) {
    var _this;

    _classCallCheck(this, InitResponseFilePart);

    _this = _super.call(this, options, uploadOptions, uploadFile, fileData);
    _this.partOptions = partOptions;
    return _this;
  }
  /**
   * Retrieves the size of the file, in bytes, as specified in the upload options.
   *
   * @returns {number} The size of the file.
   */


  _createClass(InitResponseFilePart, [{
    key: "getSize",
    value: function getSize() {
      return this.getEndOffset() - this.getStartOffset();
    }
    /**
     * Retrieves the byte offset, inclusive, of where in the file this part begins.
     *
     * @returns {number} A file byte offset.
     */

  }, {
    key: "getStartOffset",
    value: function getStartOffset() {
      return this.partOptions.start;
    }
    /**
     * Retrieves the byte offset, exclusive, of where in the file this part ends.
     *
     * @returns {number} A file byte offset.
     */

  }, {
    key: "getEndOffset",
    value: function getEndOffset() {
      return this.partOptions.end;
    }
    /**
     * Retrieves the URL to which this file part will be uploaded.
     *
     * @returns {string} A URL.
     */

  }, {
    key: "getUrl",
    value: function getUrl() {
      return this.partOptions.url;
    }
    /**
     * Retrieves the file's actual data for the part, based on the start and end offset.
     *
     * @returns {Readable|Array} A node.js stream, or an array of bytes, containing the part's data.
     */

  }, {
    key: "getData",
    value: function getData() {
      return this.getFileChunk(this.getStartOffset(), this.getEndOffset());
    }
    /**
     * Converts the instance to a simple object representation.
     *
     * @returns {object} The part data in simplified view.
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.partOptions;
    }
  }]);

  return InitResponseFilePart;
}(_initResponseFileInfo.default);

exports.default = InitResponseFilePart;